// src/services/roleService.ts

import api from "./axios";

export interface RoleInput {
    name: string;
    description?: string;
    categories: {
        id: string;
        name?: string;
        icon?: string;
        order?: number;
        permissions: { id: string }[];
    }[];
    projects: string[]; // projectIds this role grants access to
}

export const getPermissionCategories = async () => {
    const response = await api.get('/role/permission-categories');
    if (response.status === 200) {
        return { success: true, data: response.data.data };
    }
    return { success: false, message: response.data.message };
};

export const createRole = async (role: RoleInput) => {
    const response = await api.post('/role', role);
    if (response.status === 200) {
        return { success: true, data: response.data.data };
    }
    return { success: false, message: response.data.message };
};

export const updateRole = async (roleId: string, role: Partial<RoleInput>) => {
    const response = await api.put(`/role/${roleId}`, role);
    if (response.status === 200) {
        return { success: true, data: response.data.data };
    }
    return { success: false, message: response.data.message };
};

export const getRoleById = async (roleId: string) => {
    const response = await api.get(`/role/${roleId}/get-role`);
    if (response.status === 200) {
        return { success: true, data: response.data.data };
    }
    return { success: false, message: response.data.message };
};

// getRoles - optionally filter by projectId
export const getRoles = async (projectId?: string) => {
    const params = projectId ? { projectId } : {};
    const response = await api.get('/role', { params });
    if (response.status === 200) {
        return { success: true, data: response.data.data };
    }
    return { success: false, message: response.data.message };
};

export const deleteRole = async (roleId: string) => {
    const response = await api.delete(`/role/${roleId}`);
    if (response.status === 200) {
        return { success: true, data: response.data.data };
    }
    return { success: false, message: response.data.message };
};  